import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import api from './api';

import FirstPage from "./pages/FirstPage";
import Answers from './pages/Answers';
import Create from './pages/Create';
import Evaluations from './pages/Evaluations';
import Evaluation from './pages/Evaluation';
import Login from './pages/Login';
import Main from './landing_page/Main';
import CmsBar from './pages/CmsBar';
import Profile from './pages/Profile';
import Verify from './pages/Verify';
import Loader from './pages/Loader';

function App() {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const user = localStorage.getItem('user');
		if(!user){
			setLoading(false);
			return;
		}

		const tmp = JSON.parse(user);
		api.checkIfStillLogged(tmp?.token)
		.then(({data}) => {
			if(data.status === 'SUCCESS'){
				setUser(tmp);
			}else{
				localStorage.removeItem('user');
				setUser(null)
				window.location.reload();
			}
		})
			.finally(() => setTimeout(() => setLoading(false), 500));
	}, [])
  	return (
		<div className="App">
			{loading && <div className="page__loader"><Loader /></div>}
			<BrowserRouter>
				<CmsBar user={user} setUser={setUser} />
				<Routes>
					<Route index element={<Main user={user} setUser={setUser} />} />
					{ user &&
						<>	
							{ user?.user?.verified ?
								<>
									<Route path="login" element={<FirstPage user={user} setUser={setUser} />} />
									<Route path="login/:newType" element={<FirstPage user={user} setUser={setUser} />} />
									<Route path="create" exact element={<FirstPage user={user} setUser={setUser} />} />
									<Route path="create/:randomId" element={<Create user={user} setUser={setUser} />} />
									<Route path="evaluations/:id" element={<Evaluations user={user} setUser={setUser} />} />
									<Route path="evaluation/:id" element={<Evaluation user={user} setUser={setUser} />} />
									<Route path="answers/:jobId" element={<Answers user={user} setUser={setUser} />} />
									<Route path="profile" element={<Profile user={user} setUser={setUser} />} />
								</>
								:
								<>
									<Route path="/*" exact element={<Verify user={user} setUser={setUser} />} />		
								</>
							}
						</>
					}
					{!user &&
						<>
							<Route path="/*" exact element={<Login user={user} setUser={setUser} />} />
						</>
					}
					
				</Routes>
			</BrowserRouter>
		</div>
  	);
}

export default App;
